<template>
  <a-drawer
    :title="title"
    width="80%"
    :visible="visible"
    :body-style="{ paddingBottom: '80px' }"
    @close="onClose"
  >
    <a-spin :spinning="loading">
      <div class="drawer-content">
        <!-- 基本信息 -->
        <a-descriptions title="基本信息" :column="2" bordered>
          <a-descriptions-item label="统计单号">
            <a-tooltip placement="topLeft" :title="detailData.statNo">
              <span class="text-ellipsis">{{ detailData.statNo || '-' }}</span>
            </a-tooltip>
          </a-descriptions-item>
          <a-descriptions-item label="来源存储类型">
            <a-tag :color="getSourceTypeColor(detailData.sourceType)">
              {{ getSourceTypeText(detailData.sourceType) }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="存储续费类型">
            <a-tag :color="getRenewTypeColor(detailData.renewType)">
              {{ getRenewTypeText(detailData.renewType) }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="归档存储状态">
            <a-tag :color="getArchiveStorageClassColor(detailData.archiveStorageClass)">
              {{ getArchiveStorageClassText(detailData.archiveStorageClass) }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="状态">
            <a-tag :color="getStatusColor(detailData.status)">
              {{ getStatusText(detailData.status) }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="归档总容量">
            <span class="capacity-value">{{ $formatCapacity(detailData.totalArchiveCapacity) }}</span>
          </a-descriptions-item>
        </a-descriptions>

        <!-- 统计信息 -->
        <a-descriptions title="统计信息" :column="2" bordered style="margin-top: 16px">
          <a-descriptions-item label="续费金额">
            <span class="amount-value">¥{{ formatAmount(detailData.renewAmount) }}</span>
          </a-descriptions-item>
          <a-descriptions-item label="归档场景数量">{{ detailData.archiveSceneCount || 0 }}</a-descriptions-item>
          <a-descriptions-item label="来源存储池ID">{{ detailData.sourcePoolId || '-' }}</a-descriptions-item>
        </a-descriptions>

        <!-- 时间信息 -->
        <a-descriptions title="时间信息" :column="2" bordered style="margin-top: 16px">
          <a-descriptions-item label="创建时间">{{ formatTime(detailData.createTime) }}</a-descriptions-item>
          <a-descriptions-item label="到期时间">{{ formatTime(detailData.expireTime) }}</a-descriptions-item>
        </a-descriptions>

        <!-- 备注信息 -->
        <a-descriptions title="备注信息" :column="1" bordered style="margin-top: 16px">
          <a-descriptions-item label="备注">
            <a-tooltip placement="topLeft" :title="detailData.remark">
              <span class="text-ellipsis">{{ detailData.remark || '无备注' }}</span>
            </a-tooltip>
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </a-spin>

    <div class="drawer-footer">
      <a-button @click="onClose">关闭</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { getDetail } from '@/api/VR/expiredStatistics'
import moment from 'moment'

export default {
  name: 'DetailDrawer',
  data() {
    return {
      visible: false,
      loading: false,
      title: '归档统计单详情',
      detailData: {},
    }
  },
  methods: {
    show(record) {
      this.visible = true
      this.title = `归档统计单详情`
      this.loadDetail(record.id)
    },

    hide() {
      this.visible = false
      this.detailData = {}
    },

    onClose() {
      this.hide()
    },

    async loadDetail(id) {
      this.loading = true
      try {
        const response = await getDetail({
          id,
        })
        if (response.success) {
          this.detailData = response.data || {}
        } else {
          this.$message.error('加载详情失败')
        }
      } catch (error) {
        console.error('加载归档统计单详情失败:', error)
        this.$message.error('加载归档统计单详情失败')
      } finally {
        this.loading = false
      }
    },

    formatAmount(amount) {
      if (!amount && amount !== 0) return '0.00'
      return parseFloat(amount).toFixed(2)
    },

    formatCapacity(capacity) {
      if (!capacity && capacity !== 0) return '0G'
      const gb = capacity / 1024
      return `${gb.toFixed(1)}G`
    },

    formatTime(time) {
      if (!time) return '-'
      return moment(time).format('YYYY-MM-DD HH:mm:ss')
    },

    getSourceTypeText(type) {
      const typeMap = {
        1: '自有池',
        2: '企业分配池',
      }
      return typeMap[type] || '-'
    },

    getSourceTypeColor(type) {
      const colorMap = { 1: 'blue', 2: 'green' }
      return colorMap[type] || 'default'
    },

    getRenewTypeText(type) {
      const typeMap = {
        0: '标准',
        1: '开年存储',
        2: '持续存储',
      }
      return typeMap[type] || '-'
    },

    getRenewTypeColor(type) {
      const colorMap = { 0: 'blue', 1: 'green', 2: 'orange' }
      return colorMap[type] || 'default'
    },

    getArchiveStorageClassText(type) {
      const typeMap = {
        0: '标准',
        1: '低频',
        2: '深度',
      }
      return typeMap[type] || '-'
    },

    getArchiveStorageClassColor(type) {
      const colorMap = { 0: 'blue', 1: 'green', 2: 'orange' }
      return colorMap[type] || 'default'
    },

    getStatusText(status) {
      const statusMap = {
        0: '正常',
        1: '失效',
        2: '数据删除',
      }
      return statusMap[status] || '-'
    },

    getStatusColor(status) {
      const colorMap = { 0: 'green', 1: 'orange', 2: 'red' }
      return colorMap[status] || 'default'
    },
  },
}
</script>

<style scoped>
.drawer-content {
  padding: 0;
}

.drawer-footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}

.ant-descriptions {
  margin-bottom: 0;
}

.amount-value {
  font-weight: 600;
  color: #1890ff;
}

.capacity-value {
  font-weight: 600;
  color: #722ed1;
}

.text-ellipsis {
  display: inline-block;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
</style>
